<template>
  <base-link
      v-if="$isNotNullOrUndefined(userPage) && !isLoggedIn"
      class="" :class="{'a-button -primary px-12 semibold': primary}"
      :quick-link="userPage"
      :link="userPage.link && !userPage.isCheckoutLink ? removeHostFromUrl(userPage.link.url) : null"
      :target="userPage.link ? userPage.link.target : null"
  >
    <span class="d-lg-inline">{{$t('loginToSeePrice', 'Log ind for at se pris')}}</span>
  </base-link>
</template>
<script>
import BaseLink from "~/components/atoms/BaseLink.vue";
import BaseIcon from "~/components/atoms/BaseIcon.vue";

export default {
  name: 'LoginUser',
  components: {BaseIcon, BaseLink},
  props: {
    isLoggedIn: {
      type: Boolean,
      required: true
    },
    primary: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  computed: {
    siteSettings () {
      return this.$store.getters['site/getSiteSettings'];
    },
    userPage () {
      const loginLink = this.siteSettings?.loginLink;
      const myAccountLink = this.siteSettings?.myAccountLink;

      if(this.$isNotNullOrUndefined(loginLink) && this.$isNotNullOrUndefined(myAccountLink)) {
        if(this.isLoggedIn) {
          myAccountLink.name = this.$t('myAccount', 'Min konto');
          return { 'icon': 'user', 'link': myAccountLink };
        }

        loginLink.name = this.$t('login', 'Log ind');
        return { 'icon': 'user', 'link': loginLink };
      } else {
        return null
      }
    },
  },
  methods: {
    removeHostFromUrl (url){
      return url.replace('https://' + this.hostName, '')
          .replace('http://' + this.hostName, '')
    },
  }
}
</script>